import React from 'react'
import { Grid } from '@mui/material'
import PropTypes from 'prop-types'
import GlobalMessageCard from './GlobalMessageCard'
import i18n from 'simple-react-i18n'
import { NoAccounts } from '@mui/icons-material'

const ChatList = ({ messages, setSelectedMessage }) => {
    const getStyle = (i) => {
        switch (i) {
            case i === 0: return { borderTopLeftRadius: 4, borderTopRightRadius: 4 }
            case i === messages.length - 1: return { borderBottomLeftRadius: 4, borderBottomRightRadius: 4 }
            default: return {}
        }
    }
    return (
        <Grid container size={12} >
            {messages.length ?
                messages.map((message, i) => (
                    <Grid key={i} size={12}>
                        <GlobalMessageCard lastMessage={message} setSelectedMessage={setSelectedMessage} sx={ getStyle(i) }/>
                    </Grid>
                ))
                :
                <Grid container size={12} justifyContent={'center'} alignItems={'center'} sx={{ padding: 2 }}>
                    <NoAccounts sx={{ fontSize: 50 }} />
                    <Grid size={12} sx={{ fontSize: 20, textAlign: 'center' }}>{i18n.noConvs}</Grid>
                </Grid>
            }
        </Grid>
    )
}

ChatList.propTypes = {
    messages: PropTypes.arrayOf(PropTypes.shape({})),
    setSelectedMessage: PropTypes.func,
}

export default ChatList